var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.356 15.578A2.807 2.807 0 0 0 8 17.448c1.22 0 2.259-.782 2.645-1.87h-5.29zm9.498-9.347A6.232 6.232 0 0 0 8.624 0H7.376a6.232 6.232 0 0 0-6.231 6.231v3.925c0 .141-.048.279-.137.389l-.6.75a1.87 1.87 0 0 0 1.46 3.037h12.262a1.87 1.87 0 0 0 1.46-3.038l-.6-.75a.621.621 0 0 1-.137-.389V6.232z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOn);
export default __webpack_public_path__ + "static/media/bell-on.2ac65cbd1a6abdbcb7d6c9652a3a385d.svg";
export { ForwardRef as ReactComponent };